module.exports = __webpack_public_path__ + "img/bubbles.13dfc826.png";